import React from 'react';
import { CONTACT } from '../mock';
import { MessageCircle } from 'lucide-react';

export default function WhatsAppFloat() {
  const url = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent('હાય, મી One Stop Carz ની વેબસાઇટ પરથી સર્વિસ માટે પૂછવું છે.')}`;
  return (
    <a href={url} target="_blank" rel="noreferrer" className="fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-40 h-12 w-12 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform" style={{background:'linear-gradient(135deg,#25D366,#128C7E)'}} aria-label="WhatsApp">
      <MessageCircle className="w-6 h-6 text-white" />
    </a>
  );
}
